<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.assistance.name' | translate }}</span
      >
    </div>
  </div>
  <preview-validation-messages [showValidations]="showValidations" [messages]="messages"></preview-validation-messages>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div style="margin-bottom: 10px" *ngFor="let item of assistances">
      <div class="ir-row" *ngIf="item.During">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.assistance.during' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.During }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.Action !== null">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.assistance.action' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Action | assistanceaction }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.Comment">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.assistance.comment' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Comment }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
